import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f675bce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "AutoGraphFilters__container" }
const _hoisted_2 = { class: "AutoGraphFilters__actions" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_date_picker = _resolveComponent("new-date-picker")!
  const _component_new_select = _resolveComponent("new-select")!
  const _component_new_checkbox = _resolveComponent("new-checkbox")!
  const _component_new_button = _resolveComponent("new-button")!

  return (_openBlock(), _createElementBlock("form", {
    class: "AutoGraphFilters",
    onSubmit: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_new_date_picker, {
        placeholder: "Укажите период",
        value: _ctx.filters.period,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.period) = $event)),
        disabled: _ctx.disabled || _ctx.loading,
        range: "",
        format: "iso",
        "disabled-dates": "week-limit",
        "is-invalid": _ctx.filters$.period.$error,
        "validation-errors": _ctx.filters$.period.$errors
      }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
      _createVNode(_component_new_select, {
        placeholder: "Город отправки",
        value: _ctx.filters.fromCity,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.fromCity) = $event)),
        disabled: _ctx.disabled || _ctx.loading || _ctx.data_state.cities.is_loading,
        options: _ctx.data_state.cities.list,
        loading: _ctx.data_state.cities.is_loading,
        failed: _ctx.data_state.cities.is_failed,
        "error-text": "При получении списка городов произошла ошибка",
        "search-without-refresh": "",
        "can-deselect": ""
      }, null, 8, ["value", "disabled", "options", "loading", "failed"]),
      _createVNode(_component_new_select, {
        placeholder: "Город назначения",
        value: _ctx.filters.whereCity,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.whereCity) = $event)),
        disabled: _ctx.disabled || _ctx.loading || _ctx.data_state.cities.is_loading,
        options: _ctx.data_state.cities.list,
        loading: _ctx.data_state.cities.is_loading,
        failed: _ctx.data_state.cities.is_failed,
        "error-text": "При получении списка городов произошла ошибка",
        "search-without-refresh": "",
        "can-deselect": ""
      }, null, 8, ["value", "disabled", "options", "loading", "failed"]),
      _createVNode(_component_new_select, {
        placeholder: "Статус",
        value: _ctx.filters.statusId,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.statusId) = $event)),
        disabled: _ctx.disabled || _ctx.loading,
        options: _ctx.STATUSES,
        "can-deselect": ""
      }, null, 8, ["value", "disabled", "options"]),
      _createVNode(_component_new_select, {
        value: _ctx.filters.logistId,
        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.logistId) = $event)),
        placeholder: "Ответственный логист",
        loading: _ctx.data_state.logists.is_loading,
        options: _ctx.data_state.logists.list,
        failed: _ctx.data_state.logists.is_failed,
        "error-text": "При получении списка логистов произошла ошибка",
        "search-by": "name",
        "select-by": "id",
        label: "name",
        "infinite-scroll": "",
        onRefresh: _ctx.loadLogists,
        "can-deselect": ""
      }, null, 8, ["value", "loading", "options", "failed", "onRefresh"]),
      _createVNode(_component_new_checkbox, {
        class: "checkbox--blue",
        value: _ctx.state_checkbox.is_this_week,
        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state_checkbox.is_this_week) = $event)),
        label: "Текущая неделя",
        onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onCheckboxChange('this_week')))
      }, null, 8, ["value"]),
      _createVNode(_component_new_checkbox, {
        class: "checkbox--blue",
        value: _ctx.state_checkbox.is_previous_week,
        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state_checkbox.is_previous_week) = $event)),
        label: "Прошлая неделя",
        onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onCheckboxChange('previous_week')))
      }, null, 8, ["value"]),
      _createVNode(_component_new_checkbox, {
        class: "checkbox--blue",
        value: _ctx.state_checkbox.is_next_week,
        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state_checkbox.is_next_week) = $event)),
        label: "Следующая неделя",
        onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onCheckboxChange('next_week')))
      }, null, 8, ["value"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_new_button, {
        type: "button",
        disabled: _ctx.disabled || _ctx.loading,
        class: "NewButton--reset mr-3",
        onClick: _ctx.onReset
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Сбросить ")
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      _createVNode(_component_new_button, {
        type: "submit",
        disabled: _ctx.disabled || _ctx.loading,
        class: "NewButton--search"
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _createTextVNode(" Поиск ")
        ]),
        _: 1
      }, 8, ["disabled"])
    ])
  ], 32))
}